import { DemoExample } from "@/components/sections/DemoSection";

export const photoEnhancementDemo: DemoExample = {
    label: "Quality Improvement",
    beforeImage: "/images/demos/enhance/enhance-before.webp",
    afterImage: "/images/demos/enhance/enhance-after.webp",
    beforeImageSrcSet: "/images/demos/enhance/enhance-before-400w.webp 400w, /images/demos/enhance/enhance-before-800w.webp 800w",
    afterImageSrcSet: "/images/demos/enhance/enhance-after-400w.webp 400w, /images/demos/enhance/enhance-after-800w.webp 800w",
    title: "Quality Improvement",
    description: "Improve lighting, increase clarity, reduce motion blur, reduce graininess, sharpen details",
    alt: "Before and after quality improvement"
};

export const colorCorrectionDemo: DemoExample = {
    label: "Color Correction",
    beforeImage: "/images/demos/color-correction/color-correction-before.webp",
    beforeImageSrcSet: "/images/demos/color-correction/color-correction-before-400w.webp 400w, /images/demos/color-correction/color-correction-before-800w.webp 800w",
    afterImage: "/images/demos/color-correction/color-correction-after.webp",
    afterImageSrcSet: "/images/demos/color-correction/color-correction-after-400w.webp 400w, /images/demos/color-correction/color-correction-after-800w.webp 800w",
    title: "Professional Color Correction",
    description: "Adjust colors, brightness, and contrast for perfect photo quality.",
    alt: "Before and after professional color correction"
};

export const photoRestorationDemo: DemoExample = {
    label: "Photo Restoration",
    beforeImage: "/images/demos/restore/restore-before.webp",
    afterImage: "/images/demos/restore/restore-after.webp",
    beforeImageSrcSet: "/images/demos/restore/restore-before-400w.webp 400w, /images/demos/restore/restore-before-800w.webp 800w",
    afterImageSrcSet: "/images/demos/restore/restore-after-400w.webp 400w, /images/demos/restore/restore-after-800w.webp 800w",
    title: "Photo Restoration",
    description: "Repair damaged photos, fix creases, colorize black-and-white images, enhance old photos",
    alt: "Before and after restoring damaged photo"
};
